import { PerformanceData, RaAddress, RaPanel } from 'types/dist/ra-scrapper';

export type ReclameAquiData = {
  cnpj: string;
  panel: RaPanel;
  description: string;
  address: RaAddress | any;
  performanceData: PerformanceData;
  timeAgo: string;
  name: string;
  fantasyName: string;
  shortName: string;
};

export default {
  suhai: {
    cnpj: '16.825.255/0001-23',
    panel: {
      default: true,
      avg: '8.7',
      index: {
        averageAnswerTime: '332717.9619686801',
        finalScore: '8.7',
        totalNotAnswered: '0',
        totalComplains: '447',
        consumerScore: '8.08',
        created: '2021-11-09T15:06:22',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '90.3',
        type: 'SIX_MONTHS',
        totalAnswered: '447',
        totalComplains30: '109',
        averageAnswerTime3M: '384906.09426229505',
        hasStamp: 'true',
        dealAgainPercentual: '79.0',
        totalEvaluated: '195',
        answeredPercentual: '100.0',
        company: '16698',
        end: '2021-10-31T23:59:59',
        id: 'ada023e3-dc24-44f6-857a-3f7e6c56e86a',
        status: 'RA1000',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'O propósito da Suhai Seguradora é proporcionar aos motoristas acesso ao seguro com preço justo, ampliando sua liberdade e respeitando suas escolhas.<br />Seguradora devidamente registrada na SUSEP.',
    address: {
      zipCode: ' 04075-000',
      deleted: false,
      route: 'ALAMEDA IRAÉ,523',
      city: 'SÃO PAULO',
      created: '2021-06-28T14:45:34',
      modified: '2021-11-09T15:22:58',
      location: {
        deleted: false,
        created: '2021-06-28T14:45:34',
        latitude: '36.0685604',
        modified: '2021-06-28T14:45:34',
        id: 'nJBWNCM4BFFdInyS',
        longitude: '-95.86798879999999',
      },
      id: '16698ADDRESS',
      neighborhood: 'MOEMA',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '90.3',
      answeredPercentual: '100.0',
      totalComplains: '447',
      dealAgainPercentual: '79.0',
      consumerScore: '8.08',
      averageAnswerTime: '332717.9619686801',
      problems: [],
      status: 'RA1000',
    },
    timeAgo: 'Há 12 anos',
    name: 'Suhai Seguradora',
    fantasyName: 'Suhai Seguradora',
    shortName: 'suhai-seguradora',
  },
  allianz: {
    cnpj: '61573796000166',
    panel: {
      default: true,
      avg: '7.1',
      index: {
        averageAnswerTime: '587036.6444444444',
        finalScore: '7.1',
        totalNotAnswered: '0',
        totalComplains: '1125',
        consumerScore: '5.75',
        created: '2021-11-10T17:38:29',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '75.2',
        type: 'SIX_MONTHS',
        totalAnswered: '1125',
        totalComplains30: '267',
        averageAnswerTime3M: '565779.5545023697',
        hasStamp: 'false',
        dealAgainPercentual: '56.9',
        totalEvaluated: '387',
        answeredPercentual: '100.0',
        company: '770',
        end: '2021-10-31T23:59:59',
        id: 'de90fc20-e45b-4d62-a1ac-86bf7d80fbcd',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Nosso negócio é sobre pessoas. Existimos para simplificar a vida das pessoas através dos nossos produtos e serviços. E se algo acontecer, estaremos ali, para que possam contar conosco.',
    address: {
      zipCode: '01037-000',
      deleted: false,
      route: 'Rua Conselheiro Crispiniano, 58',
      city: 'São Paulo',
      created: '2020-12-10T20:24:06',
      modified: '2021-03-16T15:25:31',
      location: {
        deleted: false,
        created: '2020-12-10T20:24:06',
        latitude: '-23.5465151',
        modified: '2020-12-10T20:24:06',
        id: 'eZ7OXNvu7L_K0gzs',
        longitude: '-46.6400856',
      },
      id: 'DvVh4qd25C2_tBl-',
      neighborhood: 'República',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '75.2',
      answeredPercentual: '100.0',
      totalComplains: '1125',
      dealAgainPercentual: '56.9',
      consumerScore: '5.75',
      averageAnswerTime: '587036.6444444444',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'Allianz Seguros e SulAmérica Auto, Residencial e Condomínio.',
    fantasyName: 'Allianz Seguros e SulAmérica Auto, Residencial e Condomínio.',
    shortName: 'sulamerica-auto',
  },
  azul: {
    cnpj: '33448150000111',
    panel: {
      default: true,
      avg: '7.8',
      index: {
        averageAnswerTime: '554646.0675422138',
        finalScore: '7.8',
        totalNotAnswered: '24',
        totalComplains: '1090',
        consumerScore: '6.56',
        created: '2021-11-10T07:20:30',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '82.0',
        type: 'SIX_MONTHS',
        totalAnswered: '1066',
        totalComplains30: '301',
        averageAnswerTime3M: '566715.4365733113',
        hasStamp: 'false',
        dealAgainPercentual: '70.2',
        totalEvaluated: '329',
        answeredPercentual: '97.8',
        company: '5355',
        end: '2021-10-31T23:59:59',
        id: 'ebebe0f0-7530-47d6-abf6-de6360b2d328',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Azul Seguros preza pela qualidade nos serviços e atendimento, fazendo parte do Grupo Porto Seguro desde 2003.',
    address: {
      country: 'Brasil',
      zipCode: '20040070',
      deleted: false,
      route: 'av rio branco 80 19 andar',
      city: 'Rio de Janneiro',
      created: '2017-03-03T12:59:16',
      modified: '2021-05-07T11:50:07',
      location: { deleted: false, created: '2021-11-10T20:20:55' },
      id: '5355ADDRESS',
      neighborhood: 'centro',
      state: 'RJ',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '82.0',
      answeredPercentual: '97.8',
      totalComplains: '1090',
      dealAgainPercentual: '70.2',
      consumerScore: '6.56',
      averageAnswerTime: '554646.0675422138',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 17 anos',
    name: 'Azul Seguros',
    fantasyName: 'Azul Seguros',
    shortName: 'azul-seguros',
  },
  bradesco: {
    cnpj: '60746948000112',
    panel: {
      default: true,
      avg: '7.3',
      index: {
        averageAnswerTime: '756740.8208245243',
        finalScore: '7.3',
        totalNotAnswered: '378',
        totalComplains: '6054',
        consumerScore: '5.93',
        created: '2021-11-10T02:51:22',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '80.2',
        type: 'SIX_MONTHS',
        totalAnswered: '5676',
        totalComplains30: '1174',
        averageAnswerTime3M: '718556.7169421487',
        hasStamp: 'false',
        dealAgainPercentual: '60.8',
        totalEvaluated: '1632',
        answeredPercentual: '93.8',
        company: '757',
        end: '2021-10-31T23:59:59',
        id: 'c0b10185-14ee-470e-9281-edd153c5f188',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Bradesco Seguros está entre as maiores seguradoras do Brasil, prestando serviços para o país todo como seguro de vida, empresarial, residencial, odontológico, capitalização e previdência. ',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'hugmefree',
      created: '2016-10-31T13:12:18',
      modified: '2021-10-20T10:27:44',
      location: { deleted: false, created: '2021-11-10T20:14:26' },
      id: '757ADDRESS',
      neighborhood: 'hugmefree',
      state: 'ND',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '80.2',
      answeredPercentual: '93.8',
      totalComplains: '6054',
      dealAgainPercentual: '60.8',
      consumerScore: '5.93',
      averageAnswerTime: '756740.8208245243',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'Bradesco Seguros',
    fantasyName: 'Bradesco Seguros',
    shortName: 'bradesco-seguros',
  },
  hdi: {
    cnpj: '29980158000157',
    panel: {
      default: true,
      avg: '7.5',
      index: {
        averageAnswerTime: '705831.1244196843',
        finalScore: '7.5',
        totalNotAnswered: '3',
        totalComplains: '1080',
        consumerScore: '6.0',
        created: '2021-11-10T05:01:13',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '84.4',
        type: 'SIX_MONTHS',
        totalAnswered: '1077',
        totalComplains30: '210',
        averageAnswerTime3M: '666949.117355372',
        hasStamp: 'false',
        dealAgainPercentual: '59.8',
        totalEvaluated: '374',
        answeredPercentual: '99.7',
        company: '9227',
        end: '2021-10-31T23:59:59',
        id: '98207619-9317-448b-b9a3-4c93654006f7',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A HDI Seguros é uma empresa brasileira que atua no segmento de seguros automotivos. Pertence ao Grupo HDI e é considerado um dos maiores grupos de seguros do mundo. ',
    address: {
      country: 'Brasil',
      zipCode: '-',
      deleted: false,
      route: 'Av. Olegário Maciel, 2251 - Lourdes ',
      city: 'Belo Horizonte',
      created: '2016-11-04T11:54:25',
      modified: '2021-07-15T19:32:18',
      location: { deleted: false, created: '2021-11-10T17:07:54' },
      id: '9227ADDRESS',
      neighborhood: '-',
      state: 'MG',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '84.4',
      answeredPercentual: '99.7',
      totalComplains: '1080',
      dealAgainPercentual: '59.8',
      consumerScore: '6.0',
      averageAnswerTime: '705831.1244196843',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 14 anos',
    name: 'HDI Seguros',
    fantasyName: 'HDI Seguros',
    shortName: 'hdi-seguros',
  },
  ituran: {
    cnpj: '16613061000164',
    panel: {
      default: true,
      avg: '7.4',
      index: {
        averageAnswerTime: '122829.0082028337',
        finalScore: '7.4',
        totalNotAnswered: '0',
        totalComplains: '1341',
        consumerScore: '6.13',
        created: '2021-11-10T01:02:05',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '81.8',
        type: 'SIX_MONTHS',
        totalAnswered: '1341',
        totalComplains30: '196',
        averageAnswerTime3M: '126836.95612708018',
        hasStamp: 'false',
        dealAgainPercentual: '55.9',
        totalEvaluated: '501',
        answeredPercentual: '100.0',
        company: '2047',
        end: '2021-10-31T23:59:59',
        id: '27b69491-2667-409a-a620-ca9b3959730f',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Multinacional Israelense, presente no Brasil há 20 anos, com mais de 700 mil clientes, tem como missão proporcionar tranquilidade, protegendo e recuperando suas conquistas.',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'São Paulo',
      created: '2017-11-23T22:14:28',
      modified: '2020-03-20T19:16:54',
      location: { deleted: false, created: '2021-11-10T20:17:58' },
      id: '2047ADDRESS',
      neighborhood: 'hugmefree',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '81.8',
      answeredPercentual: '100.0',
      totalComplains: '1341',
      dealAgainPercentual: '55.9',
      consumerScore: '6.13',
      averageAnswerTime: '122829.0082028337',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 19 anos',
    name: 'Ituran Serviços',
    fantasyName: 'Ituran Serviços',
    shortName: 'ituran-sistemas-de-monitoramento',
  },
  mapfre: {
    cnpj: '61074175000138',
    panel: {
      default: true,
      avg: '7.2',
      index: {
        averageAnswerTime: '513756.3224893918',
        finalScore: '7.2',
        totalNotAnswered: '41',
        totalComplains: '1455',
        consumerScore: '5.66',
        created: '2021-11-10T08:00:11',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '81.2',
        type: 'SIX_MONTHS',
        totalAnswered: '1414',
        totalComplains30: '300',
        averageAnswerTime3M: '554763.2126200275',
        hasStamp: 'false',
        dealAgainPercentual: '55.8',
        totalEvaluated: '462',
        answeredPercentual: '97.2',
        company: '906',
        end: '2021-10-31T23:59:59',
        id: 'e3d1a767-2f21-4293-9e5d-d3103dfb4df3',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'No Brasil desde 1992, a Mapfre Seguros é uma das maiores em seu segmento e oferece seguros para carros, saúde, vida, previdência, imóveis, consórcios, capitalização e mais. ',
    address: {
      country: 'Brasil',
      zipCode: '01407200',
      deleted: false,
      route: 'Avenida Nove de Julho, 5049  -  13º',
      city: 'São Paulo',
      created: '2017-07-31T15:36:42',
      modified: '2019-06-12T11:52:25',
      location: { deleted: false, created: '2021-11-10T19:48:47' },
      id: '906ADDRESS',
      neighborhood: 'Jardim Paulista',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '81.2',
      answeredPercentual: '97.2',
      totalComplains: '1455',
      dealAgainPercentual: '55.8',
      consumerScore: '5.66',
      averageAnswerTime: '513756.3224893918',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'MAPFRE Seguros',
    fantasyName: 'MAPFRE Seguros',
    shortName: 'mapfre-seguros',
  },
  porto: {
    cnpj: '61198164000160',
    panel: {
      default: true,
      avg: '7.3',
      index: {
        averageAnswerTime: '730769.5787975809',
        finalScore: '7.3',
        totalNotAnswered: '138',
        totalComplains: '2949',
        consumerScore: '5.97',
        created: '2021-11-10T17:22:17',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '77.6',
        type: 'SIX_MONTHS',
        totalAnswered: '2811',
        totalComplains30: '861',
        averageAnswerTime3M: '768514.6023720349',
        hasStamp: 'false',
        dealAgainPercentual: '62.7',
        totalEvaluated: '962',
        answeredPercentual: '95.3',
        company: '764',
        end: '2021-10-31T23:59:59',
        id: '8679f820-2084-4ad1-b5d2-91d9e2ae622d',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Porto Seguro é uma das maiores seguradoras brasileiras da atualidade. Com mais de 70 anos de atuação no mercado, oferece seguros de diversos tipos como seguro de vida, automóvel e outros.',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'hugmefree',
      created: '2018-08-08T11:15:40',
      modified: '2021-09-27T17:21:45',
      location: {
        deleted: false,
        created: '2021-02-23T10:37:00',
        modified: '2021-03-16T17:08:32',
        id: 'WsH__f9IEEILPLnx',
      },
      id: '764ADDRESS',
      neighborhood: 'hugmefree',
      state: 'ND',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '77.6',
      answeredPercentual: '95.3',
      totalComplains: '2949',
      dealAgainPercentual: '62.7',
      consumerScore: '5.97',
      averageAnswerTime: '730769.5787975809',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'Porto Seguro',
    fantasyName: 'Porto Seguro',
    shortName: 'porto-seguro',
  },
  tokio: {
    cnpj: '33164021003540',
    panel: {
      default: true,
      avg: '7.6',
      index: {
        averageAnswerTime: '549135.7842741936',
        finalScore: '7.6',
        totalNotAnswered: '7',
        totalComplains: '999',
        consumerScore: '6.42',
        created: '2021-11-10T16:47:52',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '80.1',
        type: 'SIX_MONTHS',
        totalAnswered: '992',
        totalComplains30: '267',
        averageAnswerTime3M: '582652.3115318416',
        hasStamp: 'false',
        dealAgainPercentual: '64.1',
        totalEvaluated: '366',
        answeredPercentual: '99.3',
        company: '5722',
        end: '2021-10-31T23:59:59',
        id: '67c6a848-99c8-4a0e-93b4-0b58c6f679ca',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Tokio Marine é uma multinacional japonesa que atua no segmento de seguradora. Oferece seguros e serviços pessoais e empresariais.',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'Rio de Janeiro',
      created: '2017-08-01T18:25:53',
      modified: '2021-03-05T09:35:29',
      location: {
        deleted: false,
        created: '2021-03-05T09:09:33',
        id: '8BGak0hdiJA1NPHs',
      },
      id: '5722ADDRESS',
      neighborhood: 'hugmefree',
      state: 'RJ',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '80.1',
      answeredPercentual: '99.3',
      totalComplains: '999',
      dealAgainPercentual: '64.1',
      consumerScore: '6.42',
      averageAnswerTime: '549135.7842741936',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 17 anos',
    name: 'Tokio Marine Seguradora',
    fantasyName: 'Tokio Marine Seguradora',
    shortName: 'tokio-marine-seguradora',
  },
  aliro: {
    cnpj: '61550141000172',
    panel: {
      default: true,
      avg: '7.6',
      index: {
        averageAnswerTime: '308680.2786885246',
        finalScore: '7.6',
        totalNotAnswered: '0',
        totalComplains: '61',
        consumerScore: '6.48',
        created: '2021-11-10T10:38:04',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '81.5',
        type: 'SIX_MONTHS',
        totalAnswered: '61',
        totalComplains30: '10',
        averageAnswerTime3M: '312256.23076923075',
        hasStamp: 'false',
        dealAgainPercentual: '59.3',
        totalEvaluated: '29',
        answeredPercentual: '100.0',
        company: 'aj9rb4Qe_MOTbxxJ',
        end: '2021-10-31T23:59:59',
        id: '9896832d-e335-4e7f-921f-f529ff7afd4f',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description: null,
    address: {
      country: 'Brasil',
      zipCode: '-',
      deleted: false,
      route: '-',
      city: 'São Paulo',
      created: '2017-07-12T10:42:11',
      modified: '2019-07-17T08:59:29',
      location: {
        deleted: false,
        created: '2017-07-12T10:42:11',
        id: 'r-V7pHlJtIWjsFvP',
      },
      id: 'S_dRbBz2pV01dTG_',
      neighborhood: '-',
      state: '-',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '81.5',
      answeredPercentual: '100.0',
      totalComplains: '61',
      dealAgainPercentual: '59.3',
      consumerScore: '6.48',
      averageAnswerTime: '308680.2786885246',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 4 anos',
    name: 'Aliro Seguro',
    fantasyName: 'Aliro Seguro',
    shortName: 'aliro-seguro_182582',
  },
  itau: {
    cnpj: '60701190000104',
    panel: {
      default: true,
      avg: '7.0',
      index: {
        averageAnswerTime: '341095.26086956525',
        finalScore: '7.0',
        totalNotAnswered: '7',
        totalComplains: '1249',
        consumerScore: '6.17',
        created: '2021-11-09T05:54:41',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '68.9',
        type: 'SIX_MONTHS',
        totalAnswered: '1242',
        totalComplains30: '236',
        averageAnswerTime3M: '360143.48051948054',
        hasStamp: 'false',
        dealAgainPercentual: '56.6',
        totalEvaluated: '346',
        answeredPercentual: '99.4',
        company: '762',
        end: '2021-10-31T23:59:59',
        id: '64a474f2-2730-42ad-a09d-db80d9c80e64',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'O Itaú Seguros e Capitalizações é uma empresa do Banco Itaú que oferece serviços de seguros de vida, viagem, residencial, auto e outros.',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'hugmefree',
      created: '2017-11-23T23:09:32',
      modified: '2021-03-10T11:07:09',
      location: {
        deleted: false,
        created: '2021-02-25T14:40:55',
        id: 'AB7_P_XnVHIfA2HY',
      },
      id: '762ADDRESS',
      neighborhood: 'hugmefree',
      state: 'ND',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '68.9',
      answeredPercentual: '99.4',
      totalComplains: '1249',
      dealAgainPercentual: '56.6',
      consumerScore: '6.17',
      averageAnswerTime: '341095.26086956525',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'Itaú Seguros e Capitalização',
    fantasyName: 'Itaú Seguros e Capitalização',
    shortName: 'itau-seguros-e-capitalizacao',
  },
  liberty: {
    cnpj: '61550141000172',
    panel: {
      default: true,
      avg: '7.9',
      index: {
        averageAnswerTime: '353054.50065019506',
        finalScore: '7.9',
        totalNotAnswered: '1',
        totalComplains: '770',
        consumerScore: '6.76',
        created: '2021-11-10T09:05:19',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '82.2',
        type: 'SIX_MONTHS',
        totalAnswered: '769',
        totalComplains30: '184',
        averageAnswerTime3M: '327166.6688596491',
        hasStamp: 'false',
        dealAgainPercentual: '70.3',
        totalEvaluated: '282',
        answeredPercentual: '99.9',
        company: '2316',
        end: '2021-10-31T23:59:59',
        id: '93b03b34-94e6-43e9-8f82-2b903fd78f25',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Liberty Seguros é das maiores marcas de seguradoras da América do Norte. Oferece seguros de vida, residenciais, empresariais, para automóveis e mais. ',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'São Paulo',
      created: '2018-12-07T16:47:24',
      modified: '2021-02-26T16:37:04',
      location: {
        deleted: false,
        created: '2021-02-24T16:27:56',
        id: 'adWGuWMhEZPURxDl',
      },
      id: '2316ADDRESS',
      neighborhood: 'hugmefree',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '82.2',
      answeredPercentual: '99.9',
      totalComplains: '770',
      dealAgainPercentual: '70.3',
      consumerScore: '6.76',
      averageAnswerTime: '353054.50065019506',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 19 anos',
    name: 'Liberty Seguros',
    fantasyName: 'Liberty Seguros',
    shortName: 'liberty-seguros',
  },
  mitsui: {
    cnpj: '33016221000107',
    panel: {
      default: true,
      avg: '8.1',
      index: {
        averageAnswerTime: '341580.8491620112',
        finalScore: '8.1',
        totalNotAnswered: '0',
        totalComplains: '179',
        consumerScore: '7.05',
        created: '2021-11-10T07:49:05',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '87.2',
        type: 'SIX_MONTHS',
        totalAnswered: '179',
        totalComplains30: '46',
        averageAnswerTime3M: '332297.47540983604',
        hasStamp: 'false',
        dealAgainPercentual: '70.5',
        totalEvaluated: '79',
        answeredPercentual: '100.0',
        company: '2143',
        end: '2021-10-31T23:59:59',
        id: '84487675-ab0f-4125-8df6-8c44fb8a7409',
        status: 'GREAT',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description: null,
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'hugmefree',
      city: 'São Paulo',
      created: '2020-08-06T11:43:01',
      modified: '2021-07-05T09:27:57',
      location: { deleted: false, created: '2021-11-10T20:27:05' },
      id: 'TKlQgFQdC8L3dAUh',
      neighborhood: 'hugmefree',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '87.2',
      answeredPercentual: '100.0',
      totalComplains: '179',
      dealAgainPercentual: '70.5',
      consumerScore: '7.05',
      averageAnswerTime: '341580.8491620112',
      problems: [],
      status: 'GREAT',
    },
    timeAgo: 'Há 19 anos',
    name: 'Mitsui Sumitomo Seguros',
    fantasyName: 'Mitsui Sumitomo Seguros',
    shortName: 'mitsui-sumitomo-seguros',
  },
  pier: {
    cnpj: '13318747000134',
    panel: {
      default: true,
      avg: '9.2',
      index: {
        averageAnswerTime: '187131.88859416445',
        finalScore: '9.2',
        totalNotAnswered: '1',
        totalComplains: '378',
        consumerScore: '8.58',
        created: '2021-11-09T11:13:23',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '93.6',
        type: 'SIX_MONTHS',
        totalAnswered: '377',
        totalComplains30: '107',
        averageAnswerTime3M: '204222.7556561086',
        hasStamp: 'true',
        dealAgainPercentual: '88.8',
        totalEvaluated: '148',
        answeredPercentual: '99.7',
        company: 'k8dKf9NSSoCGuxwD',
        end: '2021-10-31T23:59:59',
        id: '300f3a04-dce8-4582-aa7d-a79b2eee2819',
        status: 'RA1000',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Oi, somos a Pier, especialistas em deixar a vida das pessoas mais leve :) Nascemos para ser o seguro que faz o melhor para as pessoas e é por isso que burocracia passa bem longe daqui.',
    address: {
      country: 'Brasil',
      zipCode: '-',
      deleted: false,
      route: '-',
      city: 'São Paulo',
      created: '2021-04-13T14:45:12',
      modified: '2021-05-14T15:12:49',
      location: { deleted: false, created: '2021-11-10T11:06:22' },
      id: '9rJvDHAOITBZPyV0',
      neighborhood: '-',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '93.6',
      answeredPercentual: '99.7',
      totalComplains: '378',
      dealAgainPercentual: '88.8',
      consumerScore: '8.58',
      averageAnswerTime: '187131.88859416445',
      problems: [],
      status: 'RA1000',
    },
    timeAgo: 'Há 4 anos',
    name: 'Pier Digital',
    fantasyName: 'Pier Digital',
    shortName: 'pier-digital',
  },
  sompo: {
    cnpj: '61383493000180',
    panel: {
      default: true,
      avg: '8.2',
      index: {
        averageAnswerTime: '872521.375',
        finalScore: '8.2',
        totalNotAnswered: '17',
        totalComplains: '313',
        consumerScore: '7.62',
        created: '2021-11-09T13:12:51',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '89.0',
        type: 'SIX_MONTHS',
        totalAnswered: '296',
        totalComplains30: '66',
        averageAnswerTime3M: '834901.2743902439',
        hasStamp: 'false',
        dealAgainPercentual: '65.1',
        totalEvaluated: '114',
        answeredPercentual: '94.6',
        company: '4706',
        end: '2021-10-31T23:59:59',
        id: '55868377-b778-4c3b-b5a3-93c6da84fcba',
        status: 'GREAT',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description: null,
    address: {
      country: 'Brasil',
      zipCode: '-',
      deleted: false,
      route: 'Rua Cubatão, 320',
      city: 'São Paulo',
      created: '2016-10-14T09:51:47',
      modified: '2021-09-01T13:39:41',
      location: { deleted: false, created: '2021-11-10T09:11:02' },
      id: '4706ADDRESS',
      neighborhood: 'Paraíso',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '89.0',
      answeredPercentual: '94.6',
      totalComplains: '313',
      dealAgainPercentual: '65.1',
      consumerScore: '7.62',
      averageAnswerTime: '872521.375',
      problems: [],
      status: 'GREAT',
    },
    timeAgo: 'Há 17 anos',
    name: 'Sompo Seguros',
    fantasyName: 'Sompo Seguros',
    shortName: 'sompo-seguros-yasuda-maritima-seguros',
  },
  sulamerica: {
    cnpj: '61573796000166',
    panel: {
      default: true,
      avg: '7.1',
      index: {
        averageAnswerTime: '587036.6444444444',
        finalScore: '7.1',
        totalNotAnswered: '0',
        totalComplains: '1125',
        consumerScore: '5.75',
        created: '2021-11-10T17:38:29',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '75.2',
        type: 'SIX_MONTHS',
        totalAnswered: '1125',
        totalComplains30: '267',
        averageAnswerTime3M: '565779.5545023697',
        hasStamp: 'false',
        dealAgainPercentual: '56.9',
        totalEvaluated: '387',
        answeredPercentual: '100.0',
        company: '770',
        end: '2021-10-31T23:59:59',
        id: 'de90fc20-e45b-4d62-a1ac-86bf7d80fbcd',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Nosso negócio é sobre pessoas. Existimos para simplificar a vida das pessoas através dos nossos produtos e serviços. E se algo acontecer, estaremos ali, para que possam contar conosco.',
    address: {
      zipCode: '01037-000',
      deleted: false,
      route: 'Rua Conselheiro Crispiniano, 58',
      city: 'São Paulo',
      created: '2020-12-10T20:24:06',
      modified: '2021-03-16T15:25:31',
      location: {
        deleted: false,
        created: '2020-12-10T20:24:06',
        latitude: '-23.5465151',
        modified: '2020-12-10T20:24:06',
        id: 'eZ7OXNvu7L_K0gzs',
        longitude: '-46.6400856',
      },
      id: 'DvVh4qd25C2_tBl-',
      neighborhood: 'República',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '75.2',
      answeredPercentual: '100.0',
      totalComplains: '1125',
      dealAgainPercentual: '56.9',
      consumerScore: '5.75',
      averageAnswerTime: '587036.6444444444',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 20 anos',
    name: 'Allianz Seguros e SulAmérica Auto, Residencial e Condomínio.',
    fantasyName: 'Allianz Seguros e SulAmérica Auto, Residencial e Condomínio.',
    shortName: 'sulamerica-auto',
  },
  youse: {
    cnpj: '34020354000110',
    panel: {
      default: true,
      avg: '7.3',
      index: {
        averageAnswerTime: '688123.7282878412',
        finalScore: '7.3',
        totalNotAnswered: '19',
        totalComplains: '825',
        consumerScore: '5.93',
        created: '2021-11-10T17:26:45',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '78.5',
        type: 'SIX_MONTHS',
        totalAnswered: '806',
        totalComplains30: '168',
        averageAnswerTime3M: '751509.4609756097',
        hasStamp: 'false',
        dealAgainPercentual: '60.3',
        totalEvaluated: '267',
        answeredPercentual: '97.7',
        company: '114028',
        end: '2021-10-31T23:59:59',
        id: 'f6267068-ed7b-4556-8d41-6ae1a1594b36',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'A Youse é uma plataforma de seguros 100% digital. A gente tá aqui pra te ouvir e fazer um atendimento de igual pra igual. Precisa de ajuda? É só chamar! ;)',
    address: {
      country: 'Brasil',
      zipCode: '-',
      deleted: false,
      route: 'ST SHN Quadra 1 Bloco E',
      city: 'Brasília',
      created: '2016-03-18T16:18:11',
      modified: '2021-10-19T17:48:18',
      location: { deleted: false, created: '2021-11-10T20:09:54' },
      id: '7i90EMRcUM1ryzUB',
      neighborhood: '-',
      state: 'DF',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '78.5',
      answeredPercentual: '97.7',
      totalComplains: '825',
      dealAgainPercentual: '60.3',
      consumerScore: '5.93',
      averageAnswerTime: '688123.7282878412',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 6 anos',
    name: 'Youse Seguros',
    fantasyName: 'Youse Seguros',
    shortName: 'youse-seguros',
  },
  zurich: {
    cnpj: '17197385007800',
    panel: {
      default: true,
      avg: '8.2',
      index: {
        averageAnswerTime: '515282.71995118976',
        finalScore: '8.2',
        totalNotAnswered: '104',
        totalComplains: '1743',
        consumerScore: '7.54',
        created: '2021-11-10T08:30:30',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '89.2',
        type: 'SIX_MONTHS',
        totalAnswered: '1639',
        totalComplains30: '355',
        averageAnswerTime3M: '435757.2317961165',
        hasStamp: 'false',
        dealAgainPercentual: '71.4',
        totalEvaluated: '463',
        answeredPercentual: '94.0',
        company: '1707',
        end: '2021-10-31T23:59:59',
        id: 'b10d03c5-5a2c-488b-b69b-8d9d01436656',
        status: 'GREAT',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Fundada na Suíça em 2013, a Zurich é uma das maiores companhias de seguro do país atualmente. Oferece seguros diversos entre individuais e empresariais.  ',
    address: {
      country: 'Brasil',
      zipCode: 'hugmefree',
      deleted: false,
      route: 'Dr.Geraldo C. Moreira , 240 - 5º andar Brooklin Novo',
      city: 'São Paulo',
      created: '2018-03-19T09:23:17',
      modified: '2019-05-13T11:06:57',
      location: { deleted: false, created: '2021-11-10T10:12:09' },
      id: '1707ADDRESS',
      neighborhood: 'hugmefree',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '89.2',
      answeredPercentual: '94.0',
      totalComplains: '1743',
      dealAgainPercentual: '71.4',
      consumerScore: '7.54',
      averageAnswerTime: '515282.71995118976',
      problems: [],
      status: 'GREAT',
    },
    timeAgo: 'Há 19 anos',
    name: 'Zurich Brasil Seguros',
    fantasyName: 'Zurich Brasil Seguros',
    shortName: 'zurich-seguros',
  },
  alfa: {
    cnpj: '02713529000188',
    panel: {
      default: true,
      avg: '7.1',
      index: {
        averageAnswerTime: '1709541.2476190475',
        finalScore: '7.1',
        totalNotAnswered: '7',
        totalComplains: '112',
        consumerScore: '5.97',
        created: '2021-11-09T16:10:05',
        companyName: '',
        start: '2021-05-01T00:00:00',
        solvedPercentual: '80.0',
        type: 'SIX_MONTHS',
        totalAnswered: '105',
        totalComplains30: '25',
        averageAnswerTime3M: '1927208.6379310344',
        hasStamp: 'false',
        dealAgainPercentual: '53.3',
        totalEvaluated: '32',
        answeredPercentual: '93.8',
        company: '3536',
        end: '2021-10-31T23:59:59',
        id: '9e4cbba8-38d3-43d8-9d11-4e2a9cf5d281',
        status: 'GOOD',
      },
      type: 'SIX_MONTHS',
      message: '',
    },
    description:
      'Fundada em 1999, a Alfa Seguradora é reconhecida pela qualidade e inovação de seus produtos, serviços e atendimento, equipe altamente especializada, com mais de 20 escritórios espalhados pelo o Brasil',
    address: {
      zipCode: '01301-000',
      deleted: false,
      route: 'Alameda Santos, 466',
      city: 'São Paulo',
      created: '2019-10-14T18:48:33',
      modified: '2019-10-14T18:48:44',
      location: {
        deleted: false,
        created: '2019-10-14T18:48:33',
        latitude: '-23.5692522',
        modified: '2019-10-14T18:48:33',
        id: 'GIUzLrkT2OB3jJU3',
        longitude: '-46.64861109999998',
      },
      id: '3536ADDRESS',
      neighborhood: 'Vila Mariana',
      state: 'SP',
      type: 'WORK',
    },
    performanceData: {
      solvedPercentual: '80.0',
      answeredPercentual: '93.8',
      totalComplains: '112',
      dealAgainPercentual: '53.3',
      consumerScore: '5.97',
      averageAnswerTime: '1709541.2476190475',
      problems: [],
      status: 'GOOD',
    },
    timeAgo: 'Há 18 anos',
    name: 'Alfa Seguradora',
    fantasyName: 'Alfa Seguradora',
    shortName: 'alfa-seguradora',
  },
};
